module.exports = __webpack_public_path__ + "static/media/cover7.bcf5c8af.jpeg";